import axios from '@ts/utils/axios';
import { ApiRequestError } from '@ts/utils/errors';
import * as stories from './stories';
import * as blogs from './blogs';

export const fetch = (params, rest = {}) =>
    axios.get('/homepage', { params, ...rest }).then(({ data }) => {
        if (data && data.meta && data.destinations && Array.isArray(data.destinations)) {
            return data;
        }

        throw new ApiRequestError('Failed fetch homePage /homepage', { params, rest });
    });

export const fetchStories = () => stories.fetchStories({ limit: 4 });

export const fetchBlogs = () => blogs.fetchBlogs({ limit: 4 });
